import { createResourceAtom } from 'lib/atoms';
import { buildSectionMutationAtom } from 'lib/atoms/section-mutation';
import type { OverviewResponse } from '../types-overview';

// Mirror of DO's atoms/overview: a resource atom for the section read + three
// section-mutation atoms for edit/confirm/revert. buildSectionMutationAtom keeps
// RC's payload keys out of api-payloads.ts (shared low-level mutation atom).
export const createOverviewResourceAtom = (href: string | undefined) =>
  createResourceAtom<OverviewResponse>(href);

export const overviewUrl = (documentId: number | string) =>
  `/documents/${documentId}/royalty_check_structuring/overview`;

export const editOverviewAtom = buildSectionMutationAtom<OverviewResponse>();
export const confirmOverviewAtom = buildSectionMutationAtom<OverviewResponse>();
export const revertOverviewAtom = buildSectionMutationAtom<OverviewResponse>();
